const authHeader = () => {
  const token = localStorage.getItem("jwt_token");
  if (token) {
    return { Authorization: `Bearer ${token}` }; // Eğer token varsa, Authorization header'ı döndür
  }
  return {}; // Eğer token yoksa, boş bir header döndür
};

export default authHeader;
